const ideas = [
  { title: 'Лендинг', hint: 'страница продукта с формой заявки' },
  { title: 'Дашборд', hint: 'таблицы и графики из базы' },
  { title: 'Магазин', hint: 'каталог, корзина и заказ' },
];

export function HomePage() {
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-2xl space-y-8">
        <div className="space-y-3">
          <h1 className="text-3xl font-bold text-slate-900 tracking-tight">
            Основа вашего проекта готова
          </h1>
          <p className="text-slate-600 leading-relaxed">
            Мы подготовили хорошую техническую основу — структуру кода, базу данных
            и готовые примеры работы с API. Дальше вы можете развивать её сами под
            свои нужды: опишите в чате, что хотите построить, и агент реализует это
            прямо здесь.
          </p>
        </div>

        <div className="rounded-lg border border-slate-200 bg-white px-4 py-3 text-sm text-slate-700 leading-relaxed">
          <span className="font-medium text-slate-900">Подсказка.</span>{' '}
          Пока агент редактирует код, эта страница обновляется автоматически —
          ничего перезагружать не нужно.
        </div>

        <a
          href="/dashboard"
          className="block rounded-lg border border-blue-200 bg-blue-50 px-4 py-3 text-sm text-blue-900 transition hover:bg-blue-100"
        >
          <span className="font-medium">Дашборд соцсетей NL →</span>{' '}
          динамика 2025–2026, новые площадки, лучшие моменты
        </a>

        <div className="space-y-3">
          <div className="text-xs font-medium text-slate-500 uppercase tracking-wider">
            Попробуйте попросить
          </div>
          <div className="grid sm:grid-cols-3 gap-3">
            {ideas.map((idea) => (
              <div
                key={idea.title}
                className="rounded-lg border border-slate-200 bg-white px-4 py-3"
              >
                <div className="text-sm font-semibold text-slate-900">{idea.title}</div>
                <div className="text-xs text-slate-500 mt-1 leading-relaxed">
                  {idea.hint}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
